import { searchWithTrail } from "@/lib/visit/address";
import { PROTECTED_ROUTES } from "@/navigation/routes";

/** The People address that visits a person, from a record address's parameters. */
export function personVisitPath(personId: string, search: string, hash: string): string {
  const params = new URLSearchParams(search);
  const access = params.getAll("view").length === 1 && params.get("view") === "access";
  params.delete("view");
  return `${PROTECTED_ROUTES.admin.people}${searchWithTrail(params.toString(), [`person:${personId}${access ? "/access" : ""}`])}${hash}`;
}
